import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import { Link } from 'react-router-dom';

const DashboardBi = () => {
  const title = 'Business Intelligence';
  const description = 'Business intelligence for Alfrus managers.';

  const submenuItems = [
    {
      name: 'Rapporto stabilimento-paese',
      path: 'stab-country',
    },
    {
      name: 'Contestazioni',
      path: 'contestazioni',
    },
    {
      name: 'Rapporto cliente-articolo',
      path: 'cli-art',
    },
    {
      name: 'Portafoglio',
      path: 'portafoglio',
    },
    {
      name: 'vendite ultimi quattro anni',
      path: 'vendite',
    },
  ];
  return (
    <>
      <HtmlHead title={title} description={description} />
      <Row>
        <Col>
          {/* Title Start */}
          <section className="scroll-section" id="title">
            <div className="page-title-container">
              <h1 className="mb-0 pb-0 display-4">{title}</h1>
            </div>
            <Row>
              {submenuItems.map((item) => {
                return (
                  <Col key={item.path}>
                    <Card body>
                      <Card.Link className="fs-5" as={Link} to={`bi/${item.path}`}>
                        {item.name}
                      </Card.Link>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </section>
          {/* Title End */}
        </Col>
      </Row>
    </>
  );
};

export default DashboardBi;
